module.exports = __webpack_public_path__ + "img/bg.cecd3c2b.png";